// BranuUserはタブごとに独立したセッションを持たせるため、JWT/refresh_token/device_uuid等を
// sessionStorageに書き込む(callback-with-branu-user.vue参照)。localStorageは同一ブラウザの
// 全タブで共有されるため、複数会社へ同時に代理ログインすると互いのセッションを上書きしてしまう。
// 通常ユーザーは従来通りlocalStorageを使う(callback.vue参照)。
// 読み出し側はどちらのユーザーかを意識せず済むよう、sessionStorageを優先しlocalStorageにフォールバックする。
export var getAuthItem = function (key) {
    var _a;
    return (_a = sessionStorage.getItem(key)) !== null && _a !== void 0 ? _a : localStorage.getItem(key);
};
// リフレッシュ等で値を更新する際、元々値が入っていたstorageに書き戻す
export var setAuthItem = function (key, value) {
    if (sessionStorage.getItem(key) !== null) {
        sessionStorage.setItem(key, value);
    }
    else {
        localStorage.setItem(key, value);
    }
};
// ログアウトやセッション破棄時は、どちらのstorageに入っていたかによらず確実に消す
export var removeAuthItem = function (key) {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
};
